import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import componentStyles from './sic-nonprofit-image-grid.css.lit';

/**
 * The nonprofit image grid component
 * @element sic-nonprofit-image-grid
 *
 * @slot images
 */

@customElement('sic-nonprofit-image-grid')
export class SicNonprofitImageGrid extends OutlineElement {
  private slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    const imageList = this.getElementsByTagName('img');

    if (imageList.length == 1) {
      return html`
        <div class="single-image">${this.slots.conditionalSlot('images')}</div>
      `;
    } else {
      return html` ${this.slots.conditionalSlot('images')} `;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-nonprofit-image-grid': SicNonprofitImageGrid;
  }
}
